import { render, staticRenderFns } from "./roomDetail.vue?vue&type=template&id=76b3bcf5&scoped=true"
import script from "./roomDetail.vue?vue&type=script&lang=js"
export * from "./roomDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b3bcf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b3bcf5')) {
      api.createRecord('76b3bcf5', component.options)
    } else {
      api.reload('76b3bcf5', component.options)
    }
    module.hot.accept("./roomDetail.vue?vue&type=template&id=76b3bcf5&scoped=true", function () {
      api.rerender('76b3bcf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/roomDetail.vue"
export default component.exports